import { Space, Typography, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { PushpinFilled } from '@ant-design/icons';

import { IOptionLabelProps } from './OptionLabel.types';

import './OptionLabel.styles.scss';

const { Text } = Typography;

const OptionLabel = ({ name, disabled, isDefault }: IOptionLabelProps) => {
  const { t } = useTranslation();

  const disabledClass = disabled ? 'np-scheme-autocomplete__option-label--disabled' : '';
  const defaultClass = isDefault ? 'np-scheme-autocomplete__option-label--default' : '';

  const getTooltip = () => {
    if (disabled) {
      return t('tooltip.partnerSchemeDeleted');
    }

    if (isDefault) {
      return t('tooltip.defaultScheme');
    }
  };

  return (
    <Tooltip title={getTooltip()}>
      <Space size={5} className={`np-scheme-autocomplete__option-label ${disabledClass} ${defaultClass}`}>
        <Text>{name}</Text>

        {isDefault && <PushpinFilled />}
      </Space>
    </Tooltip>
  );
};

export default OptionLabel;
